module.exports = __webpack_public_path__ + "static/media/400279_02.375e35bd.png";